<template>
  <div>
    <el-dialog title="Simulator Payment" :visible.sync="dialogFormFakePayment" :close-on-click-modal="false" :width="device === 'mobile' ? '95%' : ''" top="5vh">
      <el-form :model="fakePaymentForm" ref="fakePaymentForm" label-width="150px" size="small" :rules="fakePaymentFormRule" :label-position="device === 'mobile' ? 'top' : 'right'">
        <el-form-item label="Currency" prop="currency">
          <el-select v-model="fakePaymentForm.currency">
            <el-option label="GBP" value="gbp"></el-option>
            <el-option label="EUR" value="eur"></el-option>
            <el-option label="USD" value="usd"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Amount" prop="amount">
          <el-input type="number" v-model="fakePaymentForm.amount"></el-input>
        </el-form-item>
        <el-form-item label="BankholderID" prop="bankholderIDTo">
          <el-input v-model="fakePaymentForm.bankholderIDTo"></el-input>
        </el-form-item>
        <el-form-item label="Accountnumber" prop="senderAccountnumber">
          <el-input v-model="fakePaymentForm.senderAccountnumber"></el-input>
        </el-form-item>
        <el-form-item label="Iban" prop="senderIban">
          <el-input v-model="fakePaymentForm.senderIban"></el-input>
        </el-form-item>
        <el-form-item label="Bic" prop="senderBic">
          <el-input v-model="fakePaymentForm.senderBic"></el-input>
        </el-form-item>
        <el-form-item label="Reference" prop="reference">
          <el-input v-model="fakePaymentForm.reference"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormFakePayment = false">Cancel</el-button>
        <el-button type="primary" :loading="submitingFakePayment" @click="submitFakePayment()">Submit</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {fakePayment} from  '@/api/bank-account'
export default {
  computed: {
    device() {
      return this.$store.state.app.device;
    },
  },
  data() {
    return {
      dialogFormFakePayment: false,
      submitingFakePayment: false,

      fakePaymentForm: {
        currency: "gbp",
        amount: 0,
        bankholderIDTo: "",
        senderAccountnumber: "",
        senderIban: "",
        senderBic: "",
        reference: "",
      },

      fakePaymentFormRule: {
        currency: [
          {
            required: true,
            message: "Please select Currency",
            trigger: "blur",
          },
        ],
        amount: [
          {
            required: true,
            message: "Please enter Amount",
            trigger: "blur",
          },
          {
            min: 1,
            message: "Please enter Amount",
            trigger: "blur",
          },
        ],
        bankholderIDTo: [
          {
            required: true,
            message: "Please enter BankholderID",
            trigger: "blur",
          },
        ],
        senderAccountnumber: [
          {
            required: true,
            message: "Please enter Accountnumber",
            trigger: "blur",
          },
        ],
        senderIban: [
          {
            required: true,
            message: "Please enter Iban",
            trigger: "blur",
          },
        ],
        senderBic: [
          {
            required: true,
            message: "Please enter Bic",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods:{
    showDialogFakePayment(){
      if(this.$refs.fakePaymentForm) this.$refs.fakePaymentForm.resetFields()
      this.dialogFormFakePayment = true
    },
    submitFakePayment(){
      this.$refs.fakePaymentForm.validate(valid=>{
        if(valid){
          this.submitingFakePayment = true
          fakePayment(this.fakePaymentForm).then(({result})=>{
            this.submitingFakePayment = false
            if(result){
              this.dialogFormFakePayment = false
              this.$notify({
                title: 'Success',
                message: `Payment successfully`,
                type: 'success',
                duration: 2000
              });
              this.$emit('submited')
            }
          })
        }
      })
    }
  }
};
</script>

<style>
</style>